<template>
  <div class="animated fadeIn">
    <b-col
      lg="12"
      class="ml-auto"
    ></b-col>
    <b-tabs
      pills
      card
      content-class="mt-3"
    >
      <b-tab
        title="صدور استعلام"
        active
      >
        <b-card>
          <b-card
            class="shadow mb-5 bg-white rounded"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template v-slot:header>
              <b-row>
                <b-col cols="8">
                  <h6 style="display:inline">برآورد قیمت اصلی</h6>
                </b-col>
                <b-col cols="2">
                </b-col>
                <b-col cols="2">
                </b-col>
              </b-row>
            </template>
            <b-card class="shadow p-3 mb-5 bg-white rounded">
            
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="items"
                :fields="fields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align:center;vertical-align:middle; font-family: Tahoma">{{data.label }}</div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align:center;vertical-align:middle; font-family: Tahoma">{{data.value}}</div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align:center;vertical-align:middle; font-family: Tahoma">{{ (data.index + 1 ) }}</div>
                </template>
                <template v-slot:cell(customerIndex)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-input trim 
                      v-model="data.item.customerIndex"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-btn
                      variant="danger"
                      class="mr-2"
                      @click="delOffer(data.index)"
                    >x</b-btn>
                  </div>
                </template>

                <template v-slot:cell(totalPrice)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >{{(data.item.perPrice * data.item.number).toLocaleString()}}</div>
                </template>

                <template v-slot:cell(perPrice)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-input trim 
                      v-model="data.item.perPrice"
                      type="number"  :no-wheel='true'
                    ></b-form-input>
                    <br />
                    {{parseInt(data.item.perPrice).toLocaleString()}}
                  </div>
                </template>

                <template v-slot:cell(number)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-input trim 
                      v-model="data.item.number"
                      type="number"  :no-wheel='true'
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(length)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.length"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(details)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.details"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(diameter)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.diameter"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(dimensionStandard)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.dimensionStandard"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(cover)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.cover"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(material)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.material"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(description)="data">
                  <div
                    dir="ltr"
                    style="font-family: Tahoma"
                  >
                    <b-form-textarea trim 
                      v-model="data.item.description"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
              </b-table>
              <b-row class="mb-3">
                <b-col cols="9"></b-col>
                <b-col cols="3">
                  <b-btn
                    variant="success"
                    @click="addOffer()"
                    style="float: left"
                  >+ افزودن محصول</b-btn>
                </b-col>
              </b-row>
            </b-card>

            <b-row>
              <b-col cols="10">
                <vue-ckeditor
                  v-if="!showPurchaseTemrs"
                  v-model="purchaseTerms"
                  :config="config"
                ></vue-ckeditor>
                <div
                  v-if="showPurchaseTemrs"
                  v-html="purchaseTerms"
                  style="border: 1px solid black"
                  class="p-1"
                />
              </b-col>
              <b-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left;"
                  @click="togglePurchaseTerms()"
                >{{showPurchaseTemrs ? 'ویرایش متن پایین' : 'ثبت تغییرات'}}</b-btn>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="روش ارسال استعلام:"
                  label-for="sendMethod"
                >
                  <b-form-select
                    :options="sendMethods"
                    v-model="sendMethod"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <br />
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left;"
              @click="submitQuotation()"
              v-if="role=='tradeHead'  || role=='Manager'"
            >ارسال جهت تعیین قیمت</b-btn>&nbsp; &nbsp;
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left;"
              v-if="role=='trade' || role=='Manager'"
              @click="sendtoManager()"
            >ارسال به کارشناس فنی</b-btn>&nbsp; &nbsp;
            <b-btn
              variant="warning"
              class="mr-1"
              style="float: left;"
              @click="saveQuotation()"
            >ذخیره پیشنویس</b-btn>
            <b-btn
              variant="danger"
              class="mr-1"
              style="float: left;"
              v-if="role=='tradeHead'"
              @click="sendBack()"
            >برگشت به کارشناس</b-btn>
          </b-card>
          <b-card
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template v-slot:header>
              <h6>تاریخچه مشتری</h6>
            </template>
            <br />
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <template v-slot:header>
                <h6>
                  <b-input-group size="md">
                    <b-form-input trim 
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="جستجو"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                        variant="danger"
                      >حذف</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </h6>
              </template>
              <b-table
                responsive
                small
                bordered
                show-empty
                head-variant="dark"
                :items="filteredHistory"
                :fields="fieldsHistory2"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
                :filter="filter"
                @filtered="onFiltered"
              >
                <template
                  slot="top-row"
                  slot-scope="{ fields }"
                >
                  <td
                    v-for="field in fieldsHistory2"
                    :key="field.key"
                  >
                    <b-form-input trim 
                      v-if="field.label != '#' && field.key != 'operation' && field.key != 'totalPrice'"
                      v-model="filtersHistory[field.key]"
                      :placeholder="field.label"
                    ></b-form-input>
                    <p v-if="field.key == 'operation'">جستجو</p>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align:center;vertical-align:middle">{{data.label }}</div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align:center;vertical-align:middle">{{data.value}}</div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align:center;vertical-align:middle">{{ (data.index + perPage * ( currentPage - 1 )) + 1 }}</div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align:center;vertical-align:middle; width:150px">
                    <a
                      class="btn btn-primary text-light mr-1"
                      style="width: 100%"
                      :href="'/order/' + data.item.orderId"
                      target="_blank"
                      role="button"
                    >مشاهده</a>&nbsp;
                    <b-btn
                      variant="success"
                      class="mr-1"
                      style="width: 100%"
                      @click="addItem(data.item)"
                    >افزودن</b-btn>
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">{{(parseInt(data.item.perPrice) * parseInt(data.item.number)).toLocaleString()}}</template>
                <template v-slot:cell(number)="data">{{parseInt(data.item.number).toLocaleString()}}</template>
                <template v-slot:cell(perPrice)="data">{{parseInt(data.item.perPrice).toLocaleString()}}</template>

                <div
                  slot="table-busy"
                  class="text-center text-danger my-2"
                >
                <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
          <br />
        </b-card>
      </b-tab>

    </b-tabs>
    <b-modal
      id="modal"
      ref="modal"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>حذف کل موارد جدول</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <b-button
              variant="danger"
              size="lg"
              @click="doDelAll()"
            >حذف کن</b-button>
            <b-button
              variant="warning"
              size="lg"
              class="ml-2"
              @click="hideModal()"
            >لغو</b-button>
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      آیا از حذف کلیه محصولات وارد شده مطمئن هستید؟
    </b-modal>
  </div>
</template>

<script>
import Axios from 'axios'
import moment from 'moment-jalaali'
import router from '../../router'

function ConvertToCSV(objArray) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray
  var str = ''
  str =
    '"قیمت واحد (ریال)","تعداد","طول","قطر","استاندارد ابعاد","پوشش","گرید/مواد","شرح کالا"\r\n'
  for (var i = 0; i < array.length; i++) {
    var line = ''

    for (var index in array[i]) {
      if (line != '') line += ','

      line += '"' + array[i][index] + '"'
    }

    str += line + '\r\n'
  }

  return str
}

export default {
  components: {
    VueCkeditor
  },
  data: function() {
    return {
       
      rejectReason: '',
      items: [],
      filter: null,
      filter2: null,
      isBusy: true,
      currentPage: 1,
      perPage: 10,
      totalRows: '',
      batchText: '',
      batchData: [],
      itemsHistory: [],
      multiplier: 0,
      multiplierCount: 0,
      fields: [
        { key: 'operation', label: '' },
        { key: 'details', label: 'توضیحات تکمیلی' },
        { key: 'totalPrice', label: 'قیمت کل (ریال)' },
        { key: 'perPrice', label: 'قیمت واحد (ریال)' },
        { key: 'number', label: 'تعداد' },
        { key: 'length', label: 'طول' },
        { key: 'diameter', label: 'قطر' },
        { key: 'dimensionStandard', label: 'استاندارد ابعاد' },
        { key: 'cover', label: 'پوشش' },
        { key: 'material', label: 'گرید/مواد' },
        { key: 'description', label: 'شرح کالا' },
        { key: 'index', label: '#' }
      ],
      fields2: [
        { key: 'operation', label: '' },
        { key: 'details', label: 'توضیحات تکمیلی' },
        { key: 'totalPrice', label: 'قیمت کل (ریال)' },
        { key: 'perPrice', label: 'قیمت واحد (ریال)' },
        { key: 'number', label: 'تعداد' },
        { key: 'length', label: 'طول' },
        { key: 'diameter', label: 'قطر' },
        { key: 'description', label: 'شرح کالا' },
        { key: 'index', label: '#' }
      ],
      fieldsen: [
        { key: 'operation', label: '' },
        { key: 'details', label: 'Extra Details' },
        { key: 'totalPrice', label: 'Total Price (Rials)' },
        { key: 'perPrice', label: 'Unit Price (Rials)' },
        { key: 'number', label: 'Quantity' },
        { key: 'length', label: 'Length' },
        { key: 'diameter', label: 'Diameter' },
        { key: 'dimensionStandard', label: 'Size Standard' },
        { key: 'cover', label: 'Coating' },
        { key: 'material', label: 'Grade / Material' },
        { key: 'description', label: 'Description' },
        { key: 'index', label: '#' }
      ],
      fieldsCI: [
        { key: 'operation', label: '' },
        { key: 'details', label: 'توضیحات تکمیلی' },
        { key: 'totalPrice', label: 'قیمت کل (ریال)' },
        { key: 'perPrice', label: 'قیمت واحد (ریال)' },
        { key: 'number', label: 'تعداد' },
        { key: 'length', label: 'طول' },
        { key: 'diameter', label: 'قطر' },
        { key: 'dimensionStandard', label: 'استاندارد ابعاد' },
        { key: 'cover', label: 'پوشش' },
        { key: 'material', label: 'گرید/مواد' },
        { key: 'description', label: 'شرح کالا' },
        { key: 'customerIndex', label: 'ردیف مشتری' },
        { key: 'index', label: '#' }
      ],
      fields2CI: [
        { key: 'operation', label: '' },
        { key: 'details', label: 'توضیحات تکمیلی' },
        { key: 'totalPrice', label: 'قیمت کل (ریال)' },
        { key: 'perPrice', label: 'قیمت واحد (ریال)' },
        { key: 'number', label: 'تعداد' },
        { key: 'length', label: 'طول' },
        { key: 'diameter', label: 'قطر' },
        { key: 'description', label: 'شرح کالا' },
        { key: 'customerIndex', label: 'ردیف مشتری' },
        { key: 'index', label: '#' }
      ],
      fieldsenCI: [
        { key: 'operation', label: '' },
        { key: 'details', label: 'Extra Details' },
        { key: 'totalPrice', label: 'Total Price (Rials)' },
        { key: 'perPrice', label: 'Unit Price (Rials)' },
        { key: 'number', label: 'Quantity' },
        { key: 'length', label: 'Length' },
        { key: 'diameter', label: 'Diameter' },
        { key: 'dimensionStandard', label: 'Size Standard' },
        { key: 'cover', label: 'Coating' },
        { key: 'material', label: 'Grade / Material' },
        { key: 'description', label: 'Description' },
        { key: 'customerIndex', label: 'Customer Index' },
        { key: 'index', label: '#' }
      ],
      fieldsHistory: [],
      fieldsHistory2: [
        { key: 'details', label: 'توضیحات تکمیلی' },
        { key: 'totalPrice', label: 'قیمت کل' },
        { key: 'perPrice', label: 'قیمت واحد' },
        { key: 'number', label: 'تعداد' },
        { key: 'length', label: 'طول' },
        { key: 'diameter', label: 'قطر' },
        { key: 'dimensionStandard', label: 'استاندارد ابعاد' },
        { key: 'cover', label: 'پوشش' },
        { key: 'material', label: 'گرید/مواد' },
        { key: 'description', label: 'شرح کالا' },
        { key: 'customerIndex', label: 'ردیف مشتری' },
        { key: 'index', label: '#' },
        { key: 'operation', label: 'پرونده استعلام' }
      ],
      filters: {
        details: '',
        totalPrice: '',
        perPrice: '',
        number: '',
        length: '',
        diameter: '',
        dimensionStandard: '',
        cover: '',
        material: '',
        description: '',
        details: '',
        customerIndex: '',
        index: '',
        operation: ''
      },
      filtersHistory: {
        details: '',
        totalPrice: '',
        perPrice: '',
        number: '',
        length: '',
        diameter: '',
        dimensionStandard: '',
        cover: '',
        material: '',
        description: '',
        details: '',
        customerIndex: '',
        index: '',
        operation: ''
      },

      formTemplates: [
        { value: 'pk1', text: 'الگوی PK1' },
        { value: 'pk2', text: 'الگوی PK2' },
        { value: 'pken', text: 'الگوی انگلیسی' }
      ],
      formTemplate: '',
      hasCustomerIndex: false,
      hasSizeStandard: true,
      config: {
        toolbar: [
          [
            'Bold',
            'Italic',
            'Underline',
            'Strike',
            'Subscript',
            'Superscript',
            'TextColor'
          ]
        ],
        height: 200
      },
      purchaseTerms:
        '<p style="direction:rtl"><strong>ملاحظات فنی:</strong></p> <p>استاندارد ابعاد :ASME B16.5 &amp; ASME B18.2.2</p> <p>استاندارد رزوه:&nbsp;ASME B1.1 UNC FOR SIZES UP TO 1&quot; AND UN8 FOR SIZES ABOVE 1&quot; is applied</p> <p>NOTE: NUTS ARE HEAVY</p> <p style="direction:rtl">توجه: تمامی تست ها قبل از عملیات پوشش انجام خواهد شد.</p> <p style="direction:rtl">&nbsp;</p> <p style="direction:rtl"><strong>شرایط فروش</strong></p> <p style="direction:rtl">پیش پرداخت : &nbsp;50% &nbsp;الباقی پس از تاییدیه و قبل از حمل</p> <p style="direction:rtl">زمان تحویل : &nbsp; هفته کاری پس از دریافت پیش پرداخت</p> <p style="direction:rtl">مكان تحویل : &nbsp;درب كارخانه پولاد پیچ كار</p> <p style="direction:rtl">اعتبار پیشنهاد قیمت : 5 روز</p> <p style="direction:rtl">بسته بندی : كارتن یا پالت چوبی</p> <p style="direction:rtl">گواهی كیفیت مطابق MATERIAL TEST CERTIFICATE WILL BE PROVIDED ACC TO DIN EN 10204 3.1b</p> <p>&nbsp;</p>',
      customerTerms: '',
      striped: true,
      showBatchArea: false,
      showBatchTable: false,
      showPurchaseTemrs: true,
      showCustomerTerms: true,
      customerInfo: {},
      orderInfo: {},
      sendMethod: '',
      role: '',
      vat: 9,
      sendMethods: [
        { value: 'packet', text: 'پاکت دربسته' },
        { value: 'email', text: 'ایمیل' },
        { value: 'fax', text: 'فاکس' },
        { value: 'whatsapp', text: 'واتساپ' },
        { value: 'other', text: 'سایر روش‌ها (در توضیحات ذکر شود)' }
      ],
      filterFile: '',
      isBusyFile: '',
      itemsFile: [],
      fieldsFile: [
        { key: 'index', label: '#' },
        { key: 'uploadDate', label: 'تاریخ آپلود' },
        { key: 'fileName', label: 'نام فایل' },
        { key: 'subject', label: 'توضیحات' },
        { key: 'assignee', label: 'فرد بارگذاری کننده' },
        { key: 'download', label: 'دریافت' }
      ],
      journals: []
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    sendBack() {
      this.$http.put(
        this.baseUrl + 'issues/' + this.$route.params.id + '.json',
        {
          issue: {
            custom_fields: [{ id: 162, value: 'ثبت استعلام' }],
            notes: 'پیشنویس به بازرگانی برگشت داده شد.'
          }
        },
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      )
        .then(res2 => {
          alert('با موفقیت برگشت داده شد')
          router.push('/orders')
        })
        .catch(err => {
          console.log('ERR: ' + err)
        })
    },
    getTableInfo() {
      this.$http.get(
        this.baseUrl + '/issues/' + this.$route.params.customer + '.json',
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      ).then(res1 => {
        this.customerInfo = res1.data.issue
      })

      this.$http.get(
        this.baseUrl +
          '/issues.json?tracker_id=26&cf_130=' +
          this.$route.params.customer,
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      ).then(res2 => {
        let history = res2.data.issues.filter(
          x => x.id != this.$route.params.id
        )
        this.itemsHistory = []
        history = history.filter(
          z => z.custom_fields.filter(y => y.id == 156)[0].value.length > 0
        )

        history.forEach(item => {
          let tempVar = JSON.parse(
            item.custom_fields.filter(y => y.id == 156)[0].value
          )
          let tempVar2 = []
          tempVar.forEach(aa => {
            tempVar2.push(aa)
          })

          tempVar2.forEach(item2 => {
            item2.orderId = item.id
          })
          this.itemsHistory = this.itemsHistory.concat(tempVar2)
        })

        this.totalRows = this.itemsHistory.length
        this.isBusy = false
      })
      this.$http.get(
        this.baseUrl +
          '/issues/' +
          this.$route.params.id +
          '.json?include=attachments,journals',
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      ).then(res3 => {
        this.orderInfo = res3.data.issue
        this.customerTerms =
          this.orderInfo.custom_fields.filter(x => x.id == 153)[0].value ||
          '<p style="direction:rtl">شرکت ((&nbsp; ))</p> <p style="direction:rtl">جناب آقای ((&nbsp; )) مدیریت محترم ((&nbsp; ))</p> <p style="direction:rtl">با سلام احتراما ًعطف به استعلام بهای ((&nbsp; )) مورخ ((&nbsp; )) پیشنهاد فنی مربوطه به شرح ذیل تقدیم حضور میگردد.</p>'
        this.purchaseTerms =
          this.orderInfo.custom_fields.filter(x => x.id == 154)[0].value ||
          '<p style="direction:rtl"><strong>ملاحظات فنی:</strong></p> <p>استاندارد ابعاد :ASME B16.5 &amp; ASME B18.2.2</p> <p>استاندارد رزوه:&nbsp;ASME B1.1 UNC FOR SIZES UP TO 1&quot; AND UN8 FOR SIZES ABOVE 1&quot; is applied</p> <p>NOTE: NUTS ARE HEAVY</p> <p style="direction:rtl">توجه: تمامی تست ها قبل از عملیات پوشش انجام خواهد شد.</p> <p style="direction:rtl">&nbsp;</p> <p style="direction:rtl"><strong>شرایط فروش</strong></p> <p style="direction:rtl">پیش پرداخت : &nbsp;50% &nbsp;الباقی پس از تاییدیه و قبل از حمل</p> <p style="direction:rtl">زمان تحویل : &nbsp; هفته کاری پس از دریافت پیش پرداخت</p> <p style="direction:rtl">مكان تحویل : &nbsp;درب كارخانه پولاد پیچ كار</p> <p style="direction:rtl">اعتبار پیشنهاد قیمت : 5 روز</p> <p style="direction:rtl">بسته بندی : كارتن یا پالت چوبی</p> <p style="direction:rtl">گواهی كیفیت مطابق MATERIAL TEST CERTIFICATE WILL BE PROVIDED ACC TO DIN EN 10204 3.1b</p> <p>&nbsp;</p>'
        this.hasCustomerIndex =
          this.orderInfo.custom_fields.filter(x => x.id == 157)[0].value ==
          'true'
        this.hasSizeStandard =
          this.orderInfo.custom_fields.filter(x => x.id == 164)[0].value ==
          'true'
        this.formTemplate =
          this.orderInfo.custom_fields.filter(x => x.id == 152)[0].value ||
          'pk1'
        this.sendMethod = this.orderInfo.custom_fields.filter(
          x => x.id == 159
        )[0].value
        this.items = JSON.parse(
          this.orderInfo.custom_fields.filter(x => x.id == 156)[0].value
        )
        this.vat =
          this.orderInfo.custom_fields.filter(x => x.id == 165)[0].value || 9

        this.itemsFile = this.orderInfo.attachments.map(file => {
          return {
            uploadDate: moment(file.created_on).format('hh:mm jYYYY/jMM/jDD'),
            fileName: file.filename,
            subject: file.description || '-',
            assignee: file.author.name,
            download:
              'http://satrapp.ppklms.com/attachments/download/' +
              file.id +
              '?key=' +
              window.localStorage.getItem('api_key')
          }
        })

        this.isBusyFile = false

        this.journals = this.orderInfo.journals
          .filter(journal => journal.notes != '')
          .map(journal => {
            return {
              id: journal.id,
              days: moment(journal.created_on).format('hh:mm jYYYY/jMM/jDD'),
              user: journal.user.name,
              changes: journal.notes
            }
          })
      })
    },
    addOffer() {
      this.items.push({
        totalPrice: '',
        perPrice: '',
        number: '',
        length: '',
        diameter: '',
        dimensionStandard: '',
        cover: '',
        material: '',
        description: '',
        details: '',
        customerIndex: ''
      })
    },
    delOffer(order) {
      this.items.splice(order, 1)
    },
    delBatch(order) {
      this.batchData.splice(order, 1)
    },
    addItem(item) {
      this.items.push({
        totalPrice: item.totalPrice,
        perPrice: item.perPrice,
        number: item.number,
        length: item.length,
        diameter: item.diameter,
        dimensionStandard: item.dimensionStandard,
        cover: item.cover,
        material: item.material,
        description: item.description,
        customerIndex: item.customerIndex,
        details: item.details
      })
    },
    batchAdd() {
      this.showBatchArea = !this.showBatchArea
    },
    analyzeBatch() {
      let batchDataArray = this.batchText
        .split(',')
        .join('')
        .split('\n')
      if (this.hasSizeStandard) {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == 'pk1') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[10],
                perPrice: x.split('\t')[8],
                number: x.split('\t')[7],
                length: x.split('\t')[6],
                diameter: x.split('\t')[5],
                dimensionStandard: x.split('\t')[4],
                cover: x.split('\t')[3],
                material: x.split('\t')[2],
                description: x.split('\t')[1],
                customerIndex: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fieldsCI
          } else if (this.formTemplate == 'pk2') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[7],
                perPrice: x.split('\t')[5],
                number: x.split('\t')[4],
                length: x.split('\t')[3],
                diameter: x.split('\t')[2],
                description: x.split('\t')[1],
                customerIndex: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fields2CI
          } else {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[10],
                perPrice: x.split('\t')[8],
                number: x.split('\t')[7],
                length: x.split('\t')[6],
                diameter: x.split('\t')[5],
                dimensionStandard: x.split('\t')[4],
                cover: x.split('\t')[3],
                material: x.split('\t')[2],
                description: x.split('\t')[1],
                customerIndex: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fieldsenCI
          }
        } else {
          if (this.formTemplate == 'pk1') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[9],
                perPrice: x.split('\t')[7],
                number: x.split('\t')[6],
                length: x.split('\t')[5],
                diameter: x.split('\t')[4],
                dimensionStandard: x.split('\t')[3],
                cover: x.split('\t')[2],
                material: x.split('\t')[1],
                description: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fields
          } else if (this.formTemplate == 'pk2') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[6],
                perPrice: x.split('\t')[4],
                number: x.split('\t')[3],
                length: x.split('\t')[2],
                diameter: x.split('\t')[1],
                description: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fields2
          } else {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[9],
                perPrice: x.split('\t')[7],
                number: x.split('\t')[6],
                length: x.split('\t')[5],
                diameter: x.split('\t')[4],
                dimensionStandard: x.split('\t')[3],
                cover: x.split('\t')[2],
                material: x.split('\t')[1],
                description: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fieldsen
          }
        }
      } else {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == 'pk1') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[9],
                perPrice: x.split('\t')[7],
                number: x.split('\t')[6],
                length: x.split('\t')[5],
                diameter: x.split('\t')[4],
                cover: x.split('\t')[3],
                material: x.split('\t')[2],
                description: x.split('\t')[1],
                customerIndex: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fieldsCI
          } else if (this.formTemplate == 'pk2') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[9],
                perPrice: x.split('\t')[7],
                number: x.split('\t')[6],
                length: x.split('\t')[5],
                diameter: x.split('\t')[4],
                description: x.split('\t')[1],
                customerIndex: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fields2CI
          } else {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[9],
                perPrice: x.split('\t')[7],
                number: x.split('\t')[6],
                length: x.split('\t')[5],
                diameter: x.split('\t')[4],
                cover: x.split('\t')[3],
                material: x.split('\t')[2],
                description: x.split('\t')[1],
                customerIndex: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fieldsenCI
          }
        } else {
          if (this.formTemplate == 'pk1') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[8],
                perPrice: x.split('\t')[6],
                number: x.split('\t')[5],
                length: x.split('\t')[4],
                diameter: x.split('\t')[3],
                cover: x.split('\t')[2],
                material: x.split('\t')[1],
                description: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fields
          } else if (this.formTemplate == 'pk2') {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[8],
                perPrice: x.split('\t')[6],
                number: x.split('\t')[5],
                length: x.split('\t')[4],
                diameter: x.split('\t')[3],
                description: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fields2
          } else {
            this.batchData = batchDataArray.map(x => {
              return {
                details: x.split('\t')[8],
                perPrice: x.split('\t')[6],
                number: x.split('\t')[5],
                length: x.split('\t')[4],
                diameter: x.split('\t')[3],
                cover: x.split('\t')[2],
                material: x.split('\t')[1],
                description: x.split('\t')[0]
              }
            })

            this.fieldsHistory = this.fieldsen
          }
        }
      }

      this.showBatchTable = true
    },
    delAnalyzeBatch() {
      this.batchData = []
      this.showBatchTable = false
    },
    doBatchAdd() {
      this.items = this.items.concat(this.batchData)
      this.batchText = ''
      this.batchData = []
      this.showBatchTable = false
      this.showBatchArea = false
    },
    downloadCSV() {
      let a = document.createElement('a')
      let exportItems = this.items.map(item => {
        return {
          perPrice: item.perPrice,
          number: item.number,
          length: item.length,
          diameter: item.diameter,
          dimensionStandard: item.dimensionStandard,
          cover: item.cover,
          material: item.material,
          description: item.description
        }
      })
      a.href =
        'data:text/csv;charset=utf-8,\uFEFF' +
        encodeURIComponent(ConvertToCSV(JSON.stringify(exportItems)))
      a.download = 'temp' + new Date() + '.csv'
      a.click()
    },
    // gotoOrder(item) {
    //   router.push('/order/' + item)
    // },
    // کارخانه
    // وضعیت هر محصول: موجود / تولید / تامین
    // تولید: تولید شد / نشد
    // تامین: تامین شد / نشد
    // بسته بندی (جعبه چوبی / کارتن / پالت)
    // پکینگ
    // ارسال
    sendtoManager() {
      this.$http.put(
        this.baseUrl + 'issues/' + this.$route.params.id + '.json',
        {
          issue: {
            custom_fields: [
              {
                id: 152,
                value: this.formTemplate
              },
              {
                id: 153,
                value: this.customerTerms
              },
              {
                id: 154,
                value: this.purchaseTerms
              },
              {
                id: 156,
                value: JSON.stringify(this.items)
              },
              {
                id: 157,
                value: this.hasCustomerIndex
              },
              {
                id: 159,
                value: this.sendMethod
              },
              {
                id: 162,
                value: 'در انتظار بررسی فنی'
              },
              { id: 164, value: this.hasSizeStandard }
            ],
            notes: 'برآورد فنی ثبت و جهت کنترل کیفی ارجاع داده شد.'
          }
        },
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      )
        .then(res2 => {
          alert('با موفقیت افزوده شد')
          router.push('/orders')
        })
        .catch(err => {
          console.log('ERR: ' + err)
        })
    },
    submitQuotation() {
      this.$http.put(
        this.baseUrl + 'issues/' + this.$route.params.id + '.json',
        {
          issue: {
            custom_fields: [
              {
                id: 152,
                value: this.formTemplate
              },
              {
                id: 153,
                value: this.customerTerms
              },
              {
                id: 154,
                value: this.purchaseTerms
              },
              {
                id: 156,
                value: JSON.stringify(this.items)
              },
              {
                id: 157,
                value: this.hasCustomerIndex
              },
              {
                id: 159,
                value: this.sendMethod
              },
              { id: 162, value: 'تعیین قیمت توسط مدیر عامل' },
              { id: 164, value: this.hasSizeStandard }
            ],
            notes: 'پرونده جهت تعیین قیمت به مدیریت ارجاع  داده شد.'
          }
        },
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      )
        .then(res2 => {
          alert('با موفقیت افزوده شد')
          router.push('/orders')
        })
        .catch(err => {
          console.log('ERR: ' + err)
        })
    },
    saveQuotation() {
      this.$http.put(
        this.baseUrl + 'issues/' + this.$route.params.id + '.json',
        {
          issue: {
            custom_fields: [
              {
                id: 152,
                value: this.formTemplate
              },
              {
                id: 153,
                value: this.customerTerms
              },
              {
                id: 154,
                value: this.purchaseTerms
              },
              {
                id: 156,
                value: JSON.stringify(this.items)
              },
              {
                id: 157,
                value: this.hasCustomerIndex
              },
              { id: 164, value: this.hasSizeStandard }
            ],
            notes: 'پیشنویس تعیین قیمت ذخیره شد'
          }
        },
        {
          headers: {
            'X-Redmine-API-Key': window.localStorage.api_key
          }
        }
      )
        .then(res2 => {
          alert('پیشنویس ذخیره شد.')
        })
        .catch(err => {
          console.log('ERR: ' + err)
        })
    },
    togglePurchaseTerms() {
      this.showPurchaseTemrs = !this.showPurchaseTemrs
    },
    toggleCustomerTerms() {
      this.showCustomerTerms = !this.showCustomerTerms
    },
    printPreview(type) {
      let myFields =
        type == 'مالی'
          ? (this.hasCustomerIndex
              ? this.formTemplate == 'pk1'
                ? this.fieldsCI
                : this.formTemplate == 'pk2'
                ? this.fields2CI
                : this.fieldsenCI
              : this.formTemplate == 'pk1'
              ? this.fields
              : this.formTemplate == 'pk2'
              ? this.fields2
              : this.fieldsen
            ).filter(x => x.key != 'details')
          : (this.hasCustomerIndex
              ? this.formTemplate == 'pk1'
                ? this.fieldsCI
                : this.formTemplate == 'pk2'
                ? this.fields2CI
                : this.fieldsenCI
              : this.formTemplate == 'pk1'
              ? this.fields
              : this.formTemplate == 'pk2'
              ? this.fields2
              : this.fieldsen
            )
              .filter(x => x.key != 'totalPrice')
              .filter(x => x.key != 'perPrice')

      localStorage.previewItem = JSON.stringify(
        new Object({
          fields: this.hasSizeStandard
            ? myFields
            : myFields.filter(x => x.key != 'dimensionStandard'),
          customerTerms: this.customerTerms.replace('فنی / مالی', type),
          items: this.items,
          terms: this.purchaseTerms,
          order: this.orderInfo,
          type: type,
          vat: this.vat
        })
      )
      let routeData = this.$router.resolve({
        path: '/printPreview'
      })
      window.open(routeData.href, '_blank')
    },
    multiply() {
      this.items.forEach(x => {
        x.perPrice = parseInt(x.perPrice * (1 + this.multiplier / 100))
      })
      this.multiplier = 0
    },
    multiplyCount() {
      this.items.forEach(x => {
        x.number = parseInt(x.number * (1 + this.multiplierCount / 100))
      })
      this.multiplierCount = 0
    },
    delAll() {
      this.$refs['modal'].show()
    },
    hideModal() {
      this.$refs['modal'].hide()
    },
    doDelAll() {
      this.items = []
      this.hideModal()
    }
  },

  computed: {
    filtered() {
      const filtered = this.items.filter(item => {
        return Object.keys(this.filters).every(key =>
          String(item[key]).includes(this.filters[key])
        )
      })
      return filtered
    },
    filteredHistory() {
      const filteredHistory = this.itemsHistory.filter(item => {
        return Object.keys(this.filtersHistory).every(key =>
          String(item[key]).includes(this.filtersHistory[key])
        )
      })
      return filteredHistory
    }
  },

  mounted() {
    this.role = window.localStorage.getItem('role')
    this.getTableInfo()
  }
}
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url('../../assets/fonts/IRANSans(FaNum).ttf');
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

textarea {
  padding: 2px !important;
}

.table {
  font-family: Tahoma !important;
}

</style>
